import { createClient, type SupabaseClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL;
const key = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

if (!url || !key) {
  throw new Error('Missing VITE_SUPABASE_URL or VITE_SUPABASE_PUBLISHABLE_KEY');
}

// flowType: 'implicit', NOT 'pkce'.
//
// FIELD DEFECT 2026-09-05 (John, iPhone): he requested the #/admin link in
// Safari, tapped it in Apple Mail, and Mail opened it in its in-app
// SFSafariViewController — a separate browser context with separate storage. The
// PKCE code verifier lives in the context that STARTED the flow, so it was not
// there, the ?code= exchange failed silently, and he landed signed-out on the
// home page. This is not an edge case: it is what happens to every provider who
// taps the email on a phone, which is the whole audience of this console.
//
// PKCE cannot survive a cross-context hop — that binding is the point of it. The
// implicit flow puts the session in the URL fragment, so the link works in
// whichever browser opens it. The trade is a token in the URL; accepted here
// because these are 60-minute single-use magic links to a low-value console, and
// the alternative is a flow that provably does not work on the device our users
// have in their hand.
export const supabase: SupabaseClient = createClient(url, key, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    flowType: 'implicit',
  },
});
